import { createSelector } from '@reduxjs/toolkit';
import { CALL_STATUS } from '@rsos/capstone/src/constants/capabilities';

/**
 * Function to determine if the current user's authority has the `call_status` capability enabled.
 * @param {Object} state - redux state
 * @param {Object} state.psaps - PSAPS state
 */
const checkCallStatusAccessSelector = createSelector(
  state => state,
  state => {
    const isCapabilityEnabled =
      !!state.psaps?.currentPSAP?.activeCapabilities?.[CALL_STATUS];

    return isCapabilityEnabled;
  },
);

export default checkCallStatusAccessSelector;
